import React from "react";
import Style from "../assets/styles/home.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TypingEffect from "../comps/TypingEffect";

import Bg4 from "../assets/imgs/pixelLabTeam.jpeg";
// import Cards from "../assets/imgs/cards.png";
// import hazariCover from "../assets/imgs/hazari.jpg";
import shologutiIcon from "./../assets/imgs/16guti_icon.png";
import shologutiCover from "./../assets/imgs/16Guti.png";
import kittiIcon from "./../assets/imgs/kitti_icon.png";
import kittiCover from "./../assets/imgs/cover_kitti.jpg";
import blockbusterIcon from "./../assets/imgs/blockbusterIcon.png";
import blockbusterCover from "./../assets/imgs/blockbusterCover.png";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAndroid,
  faHtml5,
  faUnity,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import GameCard from "../comps/GameCard";

const Home = () => {
  // const navigate = useNavigate();

  const takeToTheFooter = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
  };
  const gameSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    // nextArrow: <button className="next">Next</button>,
    // prevArrow: <button className="prev">Prev</button>,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>

      <main className={Style.main}>
        <section className={Style.sec2}>
          <h2>
            We are PixelLab, a dynamic game development company
            specializing in the creation of engaging social. With
            a passion for creativity and cutting-edge technology, our talented
            team crafts immersive and innovative gaming experiences tailored to
            these genres.
          </h2>

        </section>

        <section className={Style.sec5}>
          <div>
            <FontAwesomeIcon icon={faUnity} />
            <FontAwesomeIcon icon={faAndroid} />
            <FontAwesomeIcon icon={faHtml5} />
          </div>
        </section>

        <section className={Style.sec4}>
          {/* <h1>PORTFOLIO</h1> */}

          {/* <Slider {...gameSliderSettings} className={Style.gameSlider}>
            <div className={Style.slide}>
              <a
                href="https://play.google.com/store/apps/details?id=com.pixellab.shologuti.offline.bead16.damro&hl=en"
                target="_blank"
                rel="noopener & noreferrer"
              >
                <img src={SholoGuti} alt="" />
              </a>
            </div>
            <div className={Style.slide}>
              <a
                href="https://play.google.com/store/apps/details?id=com.pixellab.hazari.card.game&hl=en"
                target="_blank"
                rel="noopener & noreferrer"
              >
                <img src={Hazari} alt="" />
              </a>
            </div>

            <div className={Style.slide}>
              <a
                href="https://play.google.com/store/apps/details?id=com.pixellab.card.king&hl=en"
                target="_blank"
                rel="noopener & noreferrer"
              >
                <img src={Cards} alt="" />
              </a>
            </div>
            <div className={Style.slide}>
              <a
                href="https://play.google.com/store/apps/details?id=com.pixellab.solitaire.classic.klondike&hl=en"
                target="_blank"
                rel="noopener & noreferrer"
              >
                <img src={Solitaire} alt="" />
              </a>
            </div>
          </Slider> */}

          {/* <Slider {...gameSliderSettings}> */}

          <div className={Style.slide}>
            <GameCard
              icon={shologutiIcon}
              title="Sholo Guti Pro: Online"
              publisher="PixelLab Ltd"
              // appstore=""
              playstore="https://play.google.com/store/apps/details?id=com.pixellab.shologuti.offline.bead16.damro"
              bigImage={shologutiCover}
            />
          </div>

          <div className={Style.slide}>
            <GameCard
              icon={kittiIcon}
              title="Kitti (9 Cards)"
              publisher="PixelLab Ltd"
              playstore="https://play.google.com/store/apps/details?id=com.pixellab.ninecards.kitti"
              bigImage={kittiCover}
            />
          </div>

          <div className={Style.slide}>
            <GameCard
              icon={blockbusterIcon}
              title="BlockBuster - Star Girl"
              publisher="PixelLab Ltd"
              playstore="https://play.google.com/store/apps/details?id=com.pixellab.blockbuster.puzzle"
              bigImage={blockbusterCover}
            />
          </div>

          {/* <div className={Style.slide}>
            <GameCard
              icon={Solitaire}
              title="Solitaire Classic"
              publisher="PixelLab"
              playstore="https://play.google.com/store/apps/details?id=com.pixellab.solitaire.classic.klondike"
              bigImage={Solitaire}
            />
          </div> */}

          {/* </Slider> */}



        </section>
      </main>
    </div>
  );
};

export default Home;
